import React from 'react';
import { Image, Container, Row, Col } from 'react-bootstrap';
import { ResourceImage } from '.';
import logo from '../images/logo_CareMetx.png';
import { ROUTE_PATHS } from '../utils';
import { Link } from 'react-router-dom';
import { CustomThemes } from '../utils/custom-themes';
import { CustomLinks } from '.';
import { getConfigurationDataKey } from '../utils';

interface LogoToolbarProps {
  withLinks?: boolean;
  // Optional content rendered inside the header, below the logo/links row:
  headerContent?: React.ReactNode;
}
export const LogoToolbar = ({ withLinks = true, headerContent }: LogoToolbarProps) => {
  CustomThemes();
  return (
    <Container fluid className='cmx__logo-toolbar'>
      <div className='d-flex justify-content-center justify-content-md-start'>
        <Link to={ROUTE_PATHS.login}>
          <ResourceImage
            contentKey={getConfigurationDataKey('header.logo')}
            className='cmx__logo-toolbar__image pointer'
          />
        </Link>
        <Container fluid className='cmx__loginheader' data-testid='cmx__overbrand'>
          <Container className='h-100'>
            <Row className='h-100 align-items-center flex-column flex-md-row'>{withLinks && <CustomLinks />}</Row>
          </Container>
        </Container>
      </div>
      {headerContent}
    </Container>
  );
};
